import { CSSProperties, ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";
//@ts-ignore
import Rodal from "rodal";
import "rodal/lib/rodal.css";
import "./styles.css";

type AnimationModal =
  | "zoom"
  | "fade"
  | "flip"
  | "door"
  | "rotate"
  | "slideUp"
  | "slideDown"
  | "slideLeft"
  | "slideRight";

type ModalComponentProps = {
  children: ReactNode | ReactNode[];
  visible: boolean;
  contentStyle?: CSSProperties;
  animation?: AnimationModal;
  showMask?: boolean;
};

export function Modal({
  animation = "slideDown",
  contentStyle,
  children,
  visible,
  showMask = true,
}: ModalComponentProps) {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isMounted, setIsMounted] = useState<boolean>(false);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  useEffect(() => setShowModal(visible), [visible]);

  if (typeof document === "undefined" || !isMounted) {
    return null;
  }

  return createPortal(
    <Rodal
      customStyles={contentStyle}
      animation={animation}
      visible={showModal}
      onClose={() => {}}
      showMask={showMask}
    >
      {children}
    </Rodal>,
    document.body
  );
}
